import { render } from "./ProductCta.vue?vue&type=template&id=ffed4dd0"
import script from "./ProductCta.vue?vue&type=script&lang=js"
export * from "./ProductCta.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__